import React, { useState } from 'react';
import { Box, Container, Grid, Typography, Link, TextField, Button, Divider, IconButton, Alert } from '@mui/material';
import { Instagram, Facebook, YouTube, Phone, Email, LocationOn, LinkedIn, Twitter } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import logo from '../../assets/ar-infotech-solutions.png';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <Box sx={{ backgroundColor: '#0F172A', color: '#FFFFFF', pt: 8, pb: 4 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Brand Info */}
          <Grid item xs={12} md={3}>
            <Box
              component="img"
              src={logo}
              alt="AR Infotech"
              sx={{
                height: 200,
                width: '100%',
                mb: 2,
              }}
            />
            <Typography variant="body2" sx={{ opacity: 0.8, mb: 2, lineHeight: 1.8 }}>
              AR Infotech provides 100% genuine Microsoft software licenses, including Windows OS, MS Office, and Windows Server, with instant email delivery and dedicated lifetime technical assistance.
            </Typography>
            <Box sx={{ display: 'flex', gap: 0.5, mt: 1 }}>
              <IconButton
                component="a"
                href="https://www.instagram.com/arinfotechsolutions"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on Instagram"
                sx={{ color: '#FFF', '&:hover': { color: '#E1306C', bgcolor: 'rgba(225,48,108,0.12)' }, transition: 'all 0.2s' }}
              >
                <Instagram />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.facebook.com/arinfotechsolutions"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on Facebook"
                sx={{ color: '#FFF', '&:hover': { color: '#1877F2', bgcolor: 'rgba(24,119,242,0.12)' }, transition: 'all 0.2s' }}
              >
                <Facebook />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.youtube.com/@arinfotechsolutions"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Subscribe on YouTube"
                sx={{ color: '#FFF', '&:hover': { color: '#FF0000', bgcolor: 'rgba(255,0,0,0.12)' }, transition: 'all 0.2s' }}
              >
                <YouTube />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.linkedin.com/company/ar-infotech-solutions"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Connect on LinkedIn"
                sx={{ color: '#FFF', '&:hover': { color: '#0A66C2', bgcolor: 'rgba(10,102,194,0.12)' }, transition: 'all 0.2s' }}
              >
                <LinkedIn />
              </IconButton>
            </Box>
          </Grid>

          {/* Shop Links */}
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>Shop</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link component={RouterLink} to="/shop" sx={{ color: '#FFF', opacity: 0.7, '&:hover': { opacity: 1 } }}>Windows OS</Link>
              <Link component={RouterLink} to="/shop" sx={{ color: '#FFF', opacity: 0.7, '&:hover': { opacity: 1 } }}>MS Office</Link>
              <Link component={RouterLink} to="/shop" sx={{ color: '#FFF', opacity: 0.7, '&:hover': { opacity: 1 } }}>Windows Server</Link>
              <Link component={RouterLink} to="/shop" sx={{ color: '#FFF', opacity: 0.7, '&:hover': { opacity: 1 } }}>Other Services</Link>
              <Link component={RouterLink} to="/track-order" sx={{ color: '#FFF', opacity: 0.7, '&:hover': { opacity: 1 } }}>Track Order</Link>
            </Box>
          </Grid>

          {/* Company Links */}
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>Company</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link component={RouterLink} to="/about" sx={{ color: '#FFF', opacity: 0.7, '&:hover': { opacity: 1 } }}>About Us</Link>
              <Link component={RouterLink} to="/services" sx={{ color: '#FFF', opacity: 0.7, '&:hover': { opacity: 1 } }}>Our Services</Link>
              <Link component={RouterLink} to="/our-process" sx={{ color: '#FFF', opacity: 0.7, '&:hover': { opacity: 1 } }}>How It Works</Link>
              <Link component={RouterLink} to="/contact" sx={{ color: '#FFF', opacity: 0.7, '&:hover': { opacity: 1 } }}>Contact Us</Link>
            </Box>
          </Grid>

          {/* Policies & Terms Links */}
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>Policies & Terms</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link component={RouterLink} to="/privacy-policy" sx={{ color: '#FFF', opacity: 0.7, '&:hover': { opacity: 1 } }}>Privacy Policy</Link>
              <Link component={RouterLink} to="/returns-refund-policy" sx={{ color: '#FFF', opacity: 0.7, '&:hover': { opacity: 1 } }}>Returns & Refunds</Link>
              <Link component={RouterLink} to="/terms-conditions" sx={{ color: '#FFF', opacity: 0.7, '&:hover': { opacity: 1 } }}>Terms & Conditions</Link>
              <Link component={RouterLink} to="/shipping-policy" sx={{ color: '#FFF', opacity: 0.7, '&:hover': { opacity: 1 } }}>Shipping Policy</Link>
            </Box>
          </Grid>

          {/* Contact & Newsletter */}
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>Subscribe for Updates</Typography>
            <Typography variant="body2" sx={{ opacity: 0.7, mb: 2 }}>
              Get the latest deals, activation guides, and coupon codes for Microsoft licenses.
            </Typography>
            <Box component="form" onSubmit={handleSubscribe} sx={{ display: 'flex', gap: 1, mb: 2 }}>
              <TextField
                size="small"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email Address"
                variant="outlined"
                sx={{
                  backgroundColor: '#FFF',
                  borderRadius: 1,
                  flexGrow: 1
                }}
              />
              <Button type="submit" variant="contained" color="primary" sx={{ borderRadius: 1 }}>Subscribe</Button>
            </Box>
            {subscribed && (
              <Alert severity="success" sx={{ mb: 4, py: 0 }}>
                Successfully subscribed!
              </Alert>
            )}
            {!subscribed && <Box sx={{ mb: 4 }} />}

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Phone fontSize="small" sx={{ color: 'secondary.main' }} />
                <Typography variant="body2" sx={{ opacity: 0.8 }}>+91 91132 99131</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Email fontSize="small" sx={{ color: 'secondary.main' }} />
                <Typography variant="body2" sx={{ opacity: 0.8 }}>arinfotechsolution11@gmail.com</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                <LocationOn fontSize="small" sx={{ color: 'secondary.main', mt: 0.3 }} />
                <Typography variant="body2" sx={{ opacity: 0.8 }}>Unit 101, Oxford Towers, 139/88,,<br />Hal Old Airport Rd Kodihalli, Bangalore,<br />Karnataka, India, 560008</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.1)' }} />

        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
          <Typography variant="caption" sx={{ opacity: 0.6 }}>
            © 2026 AR Infotech. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
